define(["./toastModule"], function (toastModule) {
    "use strict";

    return toastModule.service("versionService", ["$http", "$q", "$localStorage",
        function ($http, $q, $localStorage) {

            var BUCKET_URL = "https://storage.googleapis.com/tre-public-versions/tre-versions.json";
            var STORAGE_KEY = "systemVersion";

            return {
                getRemoteVersionInfo: getRemoteVersionInfo,
                isNewer: isNewer,
                shouldShow: shouldShow,
                markAsVisited: markAsVisited
            };

            function getRemoteVersionInfo() {
                return fetch(BUCKET_URL, {
                    method: "GET",
                    mode: "cors"
                }).then(function (response) {
                    if (!response.ok) {
                        throw new Error("Network GCP response was not ok");
                    }
                    return response.json();
                });
            }

            function isNewer(local, remote) {
                if (!local || !remote) return false;

                var v1 = local.split(".").slice(0, 3).map(Number);
                var v2 = remote.split(".").slice(0, 3).map(Number);

                for (var i = 0; i < v2.length; i++) {
                    if (v2[i] > (v1[i] || 0)) return true;
                    if (v2[i] < (v1[i] || 0)) return false;
                }
                return false;
            }

            function shouldShow(remoteVersion) {
                var stored = $localStorage[STORAGE_KEY];
                if (!stored) return true;

                if (stored.version !== remoteVersion) {
                    return true;
                }

                var timeDiff = new Date() - new Date(stored.visitedDate);
                return timeDiff > (7 * 24 * 60 * 60 * 1000);
            }

            function markAsVisited(version) {
                $localStorage[STORAGE_KEY] = {
                    version: version,
                    visitedDate: new Date()
                };
            }
        }
    ]);
});